import { Component, OnInit, Input } from '@angular/core';
import { SelectorComponent } from '../selector/selector.component';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-card-image-layout',
    templateUrl: './card-image-layout.component.html',
    styleUrls: ['./card-image-layout.component.scss'],
    standalone: true,
    imports: [NgStyle, SelectorComponent]
})
export class CardImageLayoutComponent implements OnInit {

	@Input() variant: string = 'rectangle';
	@Input() imageHeight: any;

	constructor() { }

	ngOnInit() {
	}

}
